import React, {useEffect} from 'react';
import {Evaluation, FormItem, Phase, Phases, SolutionItem, Solutions} from '../rest';
import {currentForm, setSolution} from '../api';
import './Solution.css';
import {CardDetails} from './Card';
import {confirmIfReplay} from "../App";

export interface SolutionProps {
  form: FormItem | undefined;
  isReplay: boolean;
  setForm: (form: FormItem) => void;
  solutions: Solutions;
  setSolution: React.Dispatch<React.SetStateAction<Solutions | undefined>>
  setCardDetails: React.Dispatch<React.SetStateAction<CardDetails | undefined>>
}

function Solution(props: SolutionProps) {
  const form = props.form;

  useEffect(() => {
    const loadCurrentForm = async () => {
      props.setForm((await currentForm()).payload);
    };

    if (!form) {
      loadCurrentForm();
    }
  }, [form, props]);

  const selectSolution = async (name: String) => {
    let newSolutions = {...props.solutions};
    const indexEstablished = newSolutions.established.findIndex(s => s.name === name);
    const indexSuggested = newSolutions.suggested.findIndex(s => s.name === name);
    if (indexEstablished !== -1) {
      newSolutions.established[indexEstablished].selected = !newSolutions.established[indexEstablished].selected;
      const item: SolutionItem = newSolutions.established[indexEstablished];
      await setSolution(item);
    }
    if (indexSuggested !== -1) {
      newSolutions.suggested[indexSuggested].selected = !newSolutions.suggested[indexSuggested].selected;
      const item: SolutionItem = newSolutions.suggested[indexSuggested];
      await setSolution(item);
    }
    props.setSolution(newSolutions);
  }

  const renderInfoButton = (solution: SolutionItem) => {
    if (solution.descriptions && solution.descriptions.length > 0) {
      return <span className="info" onClick={(e) => {
        e.stopPropagation();
        props.setCardDetails({name: solution.name, description: solution.descriptions, choices: []})
      }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path
                  d="M0 0h24v24H0V0z" fill="none"/><path
                  d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg></span>;
    }
  }

  const renderSolutions = (index: number, solutions: SolutionItem[], useEventHandlers: boolean) => {
    if (solutions.length > 0) {
      return (
        <div key={index} className="list-group">
          {solutions.map((sol, indexKey) => {
            let key = index + "_" + indexKey;
            let activeClass = ''
            let clname = 'list-group-item '
            if (index === 0) {
              activeClass = '';
            } else if (index === 1) {
              activeClass = 'list-group-item-success selected';
            } else if (index === 2) {
              activeClass = 'list-group-item-warning selected';
            }
            if (index === 1 || index === 2)
              clname += sol.selected ? `list-group-item-action ${activeClass}` : 'list-group-item-action';
            else {
              clname += "disabled";
            }
            return (
              <span
                onClick={useEventHandlers ? (e) => {
                  confirmIfReplay(props.isReplay, () => selectSolution(sol.name))
                } : () => {
                }}
                className={clname}
                key={key}>
                            <span className="solution-item">
                                <span>{sol.prompt.replaceAll("__", "")}</span>
                              {renderInfoButton(sol)}
                            </span>
                            </span>
            )
          })}
        </div>

      )
    } else {
      if (index > 0) {
        return (
          <div key={index} className="list-group">
            <span className="list-group-item disabled"><i>--</i></span>
          </div>

        )
      }
    }
  }

  const renderPhases = (phases: Phases) => {
    const getClassForPhase = (p: Phase) => {
      switch (p.rating) {
        case "ESTABLISHED":
          return "phase list-group-item-success";
        case "SUGGESTED":
          return "phase list-group-item-warning";
        default:
          return "phase list-group-item-danger";
      }
    };

    return (
      <div>
        <div className="phases-complete">
          {phases.mainPhases.phases.map((p, index) => <span key={index}
                                                            className={getClassForPhase(p)}>{p.name}</span>)}
        </div>
        <div className="phases-explanation">
          {phases.explanation.groups.map((ep, i) => {
            return <div key={i} className="phase-explanation">
              <span className="phase-explanation-title">{ep.title}</span>
              <div className="phase-explanation-phases">
                {ep.phases.map((p, index) => <span key={index} className={getClassForPhase(p)}>{p.name}</span>)}
              </div>
            </div>
          })}
        </div>
      </div>
    );
  }

  let lastEvaluation = props.solutions.lastEvaluation ? props.solutions.lastEvaluation + " Uhr" : "--";
  const renderEvaluationFromPreviousCase = (evaluations: Evaluation[]) => {
    const getValueClass = (c: Evaluation) => {
      let valueClass = "evaluation-value ";
      if (c.valuePrompt === "erfolgreich") {
        valueClass += "success";
      } else if (c.valuePrompt === "nicht erfolgreich") {
        valueClass += "failure";
      } else {
        valueClass += "skipped"
      }
      return valueClass;
    }

    return evaluations.map((c, i) =>
      <div key={i} className="list-group-item">
        <span className="evaluation">{c.questionPrompt}</span>
        {c.valuePrompt.length > 0 ?
          <span><span>: </span><span className={getValueClass(c)}>{c.valuePrompt}</span></span> : ""}
        {c.reasonPrompt.length > 0 ?
          <span><br/><small className="evaluation-reason">{c.reasonPrompt}</small></span> : ""}
      </div>);
  };


  function renderSelectedSolutionsFromPreviousCase(solutions: SolutionItem[]) {
    return solutions.map((solution, i) =>
      <div key={i} className="list-group-item">
        <span className="solution-item"><span>{solution.prompt}</span>{renderInfoButton(solution)}</span>
      </div>);
  }

  return (<div className="solution-container-inner">
      <div className={"left"}>
        {props.solutions.phases == null ? null : <div className="phases">
          <div className="section list-group-item-dark">
            <div className="section-header">{props.solutions.phases.mainPhases.title}</div>
            {renderPhases(props.solutions.phases)}
          </div>
        </div>}
        <div className="evaluation-from-previous-case">
          <div className="section list-group-item-dark">
            <div className="section-header"><span>Letzte Maßnahme</span><span
              className="previous-case-date">{lastEvaluation}</span></div>
            {renderSelectedSolutionsFromPreviousCase(props.solutions.selectedSolutionsFromPreviousCase)}
            {renderEvaluationFromPreviousCase(props.solutions.evaluationsFromPreviousCase)}
          </div>
        </div>
      </div>
      <div className="right">
        {props.solutions.selected.length > 0 ?
          <div className="section list-group-item-dark">
            <div
              className="section-header">{props.solutions.selected.length > 0 ? 'Ausgewählte Maßnahmen' : ''}</div>
            {renderSolutions(0, props.solutions.selected, false)}
          </div> : ""}
        <div className="section list-group-item-success">
          <div className="section-header">Empfohlene Maßnahmen</div>
          {renderSolutions(1, props.solutions.established, true)}
        </div>
        <div className="section list-group-item-warning">
          <div className="section-header">Bedingt empfohlene Maßnahmen</div>
          {renderSolutions(2, props.solutions.suggested, true)}
        </div>
      </div>
    </div>

  );


}

export default Solution;